import ibanCalculatorForm from './iban-calculator-form/iban-calculator-form.vue';
import ibanCalculatorResult from './iban-calculator-result/iban-calculator-result.vue';
export const TYPES = {
	DEFAULT: 'default',
	SEARCH: 'search'
};
export default {
	components: {
		ibanCalculatorForm,
		ibanCalculatorResult
	},
	data() {
		return {
			submitted: false,
			iban: null,
			submittedAccountNumber: ''
		};
	},
	props: {
		type: {
			type: String,
			required: false,
			validator(val) {
				return Object.values(TYPES).includes(val);
			},
			default: TYPES.DEFAULT
		}
	},
	computed: {
		TYPES: () => TYPES
	},
	methods: {
		showResult(ibanData) {
			this.iban = ibanData.iban;
			this.submittedAccountNumber = ibanData.submittedAccountNumber;
			this.submitted = true;
		}
	}
};
